class NotaDeclaracaoEdicao{
    constructor(){
        
    }
}

export default NotaDeclaracaoEdicao
